import {
  Barbell,
  Buildings,
  Heartbeat,
  Person,
  Spiral,
  Star,
  Target,
  type Icon,
} from '@phosphor-icons/react';
import type { GoalType, EquipmentType } from '../../../types';

export type ExperienceLevel = 'beginner' | 'some_experience' | 'intermediate' | 'advanced';

export const GOALS: { value: GoalType; label: string; icon: Icon }[] = [
  { value: 'weight_loss', label: 'Weight Loss', icon: Target },
  { value: 'muscle_gain', label: 'Muscle Gain', icon: Barbell },
  { value: 'endurance', label: 'Endurance', icon: Heartbeat },
  { value: 'general_fitness', label: 'General Fitness', icon: Star },
  { value: 'strength', label: 'Strength', icon: Barbell },
  { value: 'mobility', label: 'Mobility', icon: Person },
];

export const EXPERIENCE_LEVELS: { value: ExperienceLevel; label: string; description: string }[] = [
  { value: 'beginner', label: 'Beginner', description: 'New to working out' },
  { value: 'some_experience', label: 'Some Experience', description: 'Work out occasionally' },
  { value: 'intermediate', label: 'Regular Gym-Goer', description: 'Consistent routine' },
  { value: 'advanced', label: 'Advanced', description: 'Years of experience' },
];

export const EQUIPMENT_OPTIONS: { value: EquipmentType; label: string; icon: Icon }[] = [
  { value: 'none', label: 'Bodyweight Only', icon: Person },
  { value: 'dumbbells', label: 'Dumbbells', icon: Barbell },
  { value: 'resistance_bands', label: 'Resistance Bands', icon: Spiral },
  { value: 'kettlebell', label: 'Kettlebell', icon: Barbell },
  { value: 'barbell', label: 'Barbell', icon: Barbell },
  { value: 'gym', label: 'Full Gym Access', icon: Buildings },
];

export const DURATIONS: { value: 30 | 45 | 60; label: string }[] = [
  { value: 30, label: '30 minutes' },
  { value: 45, label: '45 minutes' },
  { value: 60, label: '60 minutes' },
];
